import { createContext, useContext } from "react";
import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "app/components";
import { useState } from "react";

const ResourcesContext = createContext();

export function ResourcesProvider({ children }) {
  const [ciudades, setCiudades] = useState();

  const denominacionesSocialesQuery = useQuery({
    queryKey: ["resources:get:denominaciones-sociales"],
    queryFn: resourcesService.getDenominacionesSociales,
  });

  const representacionesGeograficasQuery = useQuery({
    queryKey: ["resources:get:representaciones-geograficas"],
    queryFn: resourcesService.getRepresentacionesGeograficas,
  });

  const departamentosDeHondurasQuery = useQuery({
    queryKey: ["resources:get:departamentos-de-honduras"],
    queryFn: resourcesService.getDepartamentosDeHonduras,
    onSuccess: (data) => {
      const cities = [];

      data.results.forEach((dep) => {
        cities.push(dep.ciudades);
      });

      setCiudades(cities.flat());
    },
  });

  // const ciudadesQuery = useQuery({
  //   queryKey: ["resources:get:ciudades"],
  //   queryFn: resourcesService.getCiudades,
  // });

  const cargosQuery = useQuery({
    queryKey: ["resources:get:cargos"],
    queryFn: resourcesService.getCargos,
  });

  const camarasDeComercioQuery = useQuery({
    queryKey: ["resources:get:camaras-de-comercio"],
    queryFn: resourcesService.getCamarasDeComercio,
  });

  const decretosLegislativosQuery = useQuery({
    queryKey: ["resources:get:decretos-legislativos"],
    queryFn: resourcesService.getDecretosLegislativos,
  });

  const formasDePagoQuery = useQuery({
    queryKey: ["resources:get:formas-de-pago"],
    queryFn: resourcesService.getFormasDePago,
  });

  const frecuenciasDePagoQuery = useQuery({
    queryKey: ["resources:get:frecuencias-de-pago"],
    queryFn: resourcesService.getFrecuenciasDePago,
  });

  const generosQuery = useQuery({
    queryKey: ["resources:get:generos"],
    queryFn: resourcesService.getGeneros,
  });

  const clasesPorGrupoQuery = useQuery({
    queryKey: ["resources:get:clases-por-grupo"],
    queryFn: resourcesService.getClasesPorGrupo,
  });

  const actividadesEconomicasQuery = useQuery({
    queryKey: ["resources:get:actividades-economicas"],
    queryFn: resourcesService.getActividadesEconomicas,
  });

  function getDepartamento(departamentoId) {
    const departamento = departamentosDeHondurasQuery.data.results.find(
      (depto) => depto.departamento_id === departamentoId
    );

    return departamento;
  }

  function getDepartamentoByCiudadId(ciudadId) {
    const departamento = departamentosDeHondurasQuery.data.results.find(
      (d) => !!d.ciudades.find((c) => c.ciudad_id === ciudadId)
    );

    return departamento;
  }

  function getCiudad(ciudadId) {
    const departamento = departamentosDeHondurasQuery.data.results.find((d) =>
      d.ciudades.find((c) => c.ciudad_id === ciudadId)
    );

    return departamento.ciudades.find((c) => c.ciudad_id === ciudadId);

    // const ciudad = ciudadesQuery.data.find((c) => c.ciudad_id === ciudadId);

    // return ciudad;
  }

  function getNombreDeCiudad(ciudadId) {
    const departamento = departamentosDeHondurasQuery.data.results.find((d) =>
      d.ciudades.find((c) => c.ciudad_id === ciudadId)
    );

    const ciudad = departamento.ciudades.find((c) => c.ciudad_id === ciudadId);

    return `${ciudad.ciudad_nombre}, ${departamento.departamento_nombre}`;

    // const ciudad = ciudadesQuery.data.find((c) => c.ciudad_id === ciudadId);

    // return ciudad.ciudad_nombre;
  }

  function getClase(claseId) {
    const clase = clasesPorGrupoQuery.data.results.find(
      (clase) => clase.clase_id === claseId
    );

    return clase;
  }

  function getClaseByActividadEconomicaId(actividadEconomicaId) {
    const clase = clasesPorGrupoQuery.data.results.find(
      (clase) =>
        !!clase.actividades_economicas.find(
          (a) => a.actividad_economica_id === actividadEconomicaId
        )
    );

    return clase;
  }

  if (
    denominacionesSocialesQuery.isLoading ||
    representacionesGeograficasQuery.isLoading ||
    camarasDeComercioQuery.isLoading ||
    departamentosDeHondurasQuery.isLoading ||
    // ciudadesQuery.isLoading ||
    cargosQuery.isLoading ||
    formasDePagoQuery.isLoading ||
    frecuenciasDePagoQuery.isLoading ||
    generosQuery.isLoading ||
    clasesPorGrupoQuery.isLoading
  ) {
    return <Spinner label="Cargando los recursos del sistema..." />;
  }

  return (
    <ResourcesContext.Provider
      value={{
        denominacionesSociales: denominacionesSocialesQuery.data,
        representacionesGeograficas: representacionesGeograficasQuery.data,
        decretosLegislativos: decretosLegislativosQuery.data,
        departamentosDeHonduras: departamentosDeHondurasQuery.data,
        ciudades,
        camarasDeComercio: camarasDeComercioQuery.data,
        getDepartamento,
        getDepartamentoByCiudadId,
        getCiudad,
        getNombreDeCiudad,
        cargos: cargosQuery.data,
        formasDePago: formasDePagoQuery.data,
        frecuenciasDePago: frecuenciasDePagoQuery.data,
        generos: generosQuery.data,
        clases: clasesPorGrupoQuery.data,
        actividadesEconomicas: actividadesEconomicasQuery.data,
        getClase,
        getClaseByActividadEconomicaId,
      }}
    >
      {children}
    </ResourcesContext.Provider>
  );
}

export function useResourcesContext() {
  const resourcesContext = useContext(ResourcesContext);

  if (!resourcesContext) {
    throw new Error(
      "useResourcesContext should be used inside the ResourcesProvider."
    );
  }

  return resourcesContext;
}
